import 'stylesheets/pages/event/akiya_katsuyou/style';

import SmoothScroll from 'smooth-scroll';
import Modal from 'modules/Modal';
import NeedSignupPromptModal from 'modules/NeedSignupPromptModal';
import SelectScoutMessage from 'modules/SelectScoutMessage';
import AkiyaKatsuyouList from 'modules/AkiyaKatsuyouList';

new Modal();
new NeedSignupPromptModal();
new SelectScoutMessage();

new SmoothScroll('a[href*="#"]', {
  easing: 'easeInOutCubic',
  ignore: '[data-scroll-ignore]',
  offset: 60,
  updateURL: false,
  popstate: true,
});

new AkiyaKatsuyouList();
